DoneComponent = require 'views/enterprise/dashboard/bulk-actions/progress-component/done-component'
RunningComponent = require 'views/enterprise/dashboard/bulk-actions/progress-component/running-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')()

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @state = {
      state: 'running'
    }

  componentWillReceiveProps: (nextProps) ->
    if nextProps.processed == nextProps.total
      @setState state: 'done'

  render: t.renderable ->
    if @state.state == 'running'
      t.addElement React.createElement RunningComponent,
        total: @props.total
        processed: @props.processed
    else
      t.addElement React.createElement @props.doneComponent || DoneComponent,
        results: @props.results
        modelLabel: @props.modelLabel
        modelName: @props.modelName
        onDoneClick: @props.onDoneClick
        enterpriseDisplayName: @props.enterpriseDisplayName



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions/progress-component/display-component.coffee